const rand = (a, b) => a + Math.random() * (b - a);
const gauss = () => (Math.random() + Math.random() + Math.random() - 1.5) / 1.5;

const sky = (size) => {
  const c = Object.assign(document.createElement("canvas"), { width: size, height: size });
  const g = c.getContext("2d");
  const m = size / 2;
  g.fillStyle = "#04050c";
  g.fillRect(0, 0, size, size);
  g.translate(m, m);
  g.rotate(-0.45);
  g.globalCompositeOperation = "lighter";
  const haze = [[220, 30, 70], [265, 35, 60], [30, 45, 65], [200, 25, 75]];
  for (let i = 0; i < 260; i++) {
    const x = rand(-m, m), y = gauss() * size * 0.09, r = rand(size * 0.03, size * 0.11);
    const [hu, sa, li] = haze[i % haze.length];
    const grd = g.createRadialGradient(x, y, 0, x, y, r);
    grd.addColorStop(0, `hsla(${hu},${sa}%,${li}%,0.05)`);
    grd.addColorStop(1, `hsla(${hu},${sa}%,${li}%,0)`);
    g.fillStyle = grd;
    g.fillRect(x - r, y - r, r * 2, r * 2);
  }
  g.globalCompositeOperation = "source-over";
  for (let i = 0; i < 140; i++) {
    const x = rand(-m, m), y = gauss() * size * 0.025, r = rand(size * 0.01, size * 0.035);
    const grd = g.createRadialGradient(x, y, 0, x, y, r);
    grd.addColorStop(0, "rgba(4,4,10,0.18)");
    grd.addColorStop(1, "rgba(4,4,10,0)");
    g.fillStyle = grd;
    g.fillRect(x - r, y - r, r * 2, r * 2);
  }
  g.globalCompositeOperation = "lighter";
  for (let i = 0; i < 9000; i++) {
    const inBand = Math.random() < 0.7;
    const x = rand(-m, m), y = inBand ? gauss() * size * 0.11 : rand(-m, m);
    g.fillStyle = `rgba(${Math.floor(rand(200, 255))},${Math.floor(rand(210, 240))},255,${rand(0.15, 0.7)})`;
    g.fillRect(x, y, rand(0.6, 1.6), rand(0.6, 1.6));
  }
  return c;
};

export const milkyway = {
  id: "milkyway",
  name: "silent blip",
  subtitle: "The Milky Way, a soft river of stars drifting across the night",
  init(w, h) {
    const size = Math.ceil(Math.hypot(w, h)) + 40;
    const stars = Array.from({ length: 140 }, () => ({
      a: rand(0, Math.PI * 2), d: Math.sqrt(Math.random()) * size * 0.5,
      r: rand(0.6, 1.8), ph: rand(0, Math.PI * 2), sp: rand(0.15, 0.5),
    }));
    return { bg: sky(size), size, stars };
  },
  draw(ctx, w, h, t, s) {
    const rot = t * 0.004;
    ctx.globalCompositeOperation = "source-over";
    ctx.fillStyle = "#04050c";
    ctx.fillRect(0, 0, w, h);
    ctx.save();
    ctx.translate(w / 2, h / 2);
    ctx.rotate(rot);
    ctx.drawImage(s.bg, -s.size / 2, -s.size / 2);
    ctx.globalCompositeOperation = "lighter";
    s.stars.forEach((st) => {
      const a = 0.35 + 0.35 * Math.sin(t * st.sp + st.ph);
      ctx.fillStyle = `rgba(235,240,255,${a})`;
      ctx.beginPath();
      ctx.arc(Math.cos(st.a) * st.d, Math.sin(st.a) * st.d, st.r, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.restore();
    ctx.globalCompositeOperation = "source-over";
  },
};
